import { PrimaryLinkArrow } from '../../../styles';
import { Link } from '../../types';
import { DesktopMenuLink } from '../desktopMenu.style';
import styled from 'styled-components';

export const DesktopPrimaryLinkContainer = styled.span`
  margin-top: 1.5rem;
`;

export const PrimaryLink = styled(DesktopMenuLink)`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #be1d3d;
  font-weight: 700;
`;

export const DesktopMenuPrimaryLink = ({ link }: { link: Link }) => {
  return (
    <DesktopPrimaryLinkContainer>
      <PrimaryLink href={link.href}>
        {link.text}
        <PrimaryLinkArrow />
      </PrimaryLink>
    </DesktopPrimaryLinkContainer>
  );
};
